import { answerOptions } from '../components/organisms/QuestionAnswers/answerOptions';

/**
 * Formats a date to a specified format
 * @param {Date} date - The date to format
 * @param {string} format - The format to use ('date' or 'dateTime')
 * @returns {string | null | undefined} The formatted date string, null if no date provided, or undefined if format unrecognized
 */
export const formatDate = (date, format) => {
  let newDate;
  let dateOptions;

  if (date) {
    if (format === 'date') {
      dateOptions = {
        year: 'numeric',
        day: 'numeric',
        month: 'numeric',
      };
      // @ts-ignore
      newDate = new Date(date).toLocaleDateString('en-US', dateOptions);
    } else if (format === 'dateTime') {
      dateOptions = {
        year: 'numeric',
        day: 'numeric',
        month: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
      };
      // @ts-ignore
      newDate = new Date(date).toLocaleString('en-US', dateOptions);
    }
  } else {
    newDate = null;
  }
  return newDate;
};
/**
 * Adds days to a date
 * @param {Date} date - The date to add days to
 * @param {number} days - Number of days to add
 * @returns {string} The resulting date as a formatted string
 */
export const addDays = (date, days) => {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  // @ts-ignore
  result = formatDate(result, 'dateTime');
  // @ts-ignore
  return result.replace(',', '');
};

/**
 * Subtracts days from a date
 * @param {Date} date - The date to subtract days from
 * @param {number} days - Number of days to subtract
 * @returns {string} The resulting date as a formatted string
 */
export const subtractDays = (date, days) => {
  let result = new Date(date);
  result.setDate(result.getDate() - days);
  // @ts-ignore
  result = formatDate(result, 'dateTime');
  // @ts-ignore
  return result.replace(',', '');
};

/**
 * Adds hours to a date
 * @param {Date} date - The date to add hours to
 * @param {number} hours - Number of hours to add
 * @returns {string} The resulting date as a formatted string
 */
export const addHours = (date, hours) => {
  let result = new Date(date);
  result.setHours(result.getHours() + hours);
  // @ts-ignore
  result = formatDate(result, 'dateTime');
  // @ts-ignore
  return result.replace(',', '');
};

/**
 * Gets a URL parameter by name
 * @param {string} name - The parameter name
 * @returns {string | null} The parameter value or null
 */
export const getParam = (name) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};

/**
 * Sets a URL parameter
 * @param {string} name - The parameter name
 * @param {string} value - The parameter value
 * @returns {void}
 */
export const setParam = (name, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(name, value);
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState(null, '', newUrl);
};

/**
 * Converts the list of followUpQuestions to questionAnswers list which is used as parameter in graphql APIs
 * @param {import('../components/pages/EquipActionPortal/questionTypes').FollowUpQuestion[]} followUpQuestions
 * @returns {import('../components/pages/EquipActionPortal/questionTypes').QuestionAnswer[]}
 */
export const followUpQuestionsToQuestionAnswers = (followUpQuestions) =>
  followUpQuestions
    .filter((question) => question.selectedAnswer !== answerOptions.NONE_SELECTED)
    .map((question) => ({
      id: question.id,
      selectedAnswer: question.selectedAnswer,
      freeTextAnswer: question.additionalDetails,
    }));
